<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2s"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="toca"><a href="#/xhtml/acknowledgments#ack">· <em>Acknowledgments</em></a></p>
<p class="toca"><a href="#/xhtml/abbreviations#abb">· <em>List of Abbreviations</em></a></p>
<p class="tocat"><a href="#/xhtml/introduction#int">· Introduction</a></p>
<p class="toc"><a href="#/xhtml/chapter01#ch1">1 From Structure to Task</a></p>
<p class="toc"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample">2 Historical Belonging as Finite Freedom</span></p>
<p class="toc"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample">3 The Infinity of the Dialogue</span></p>
<p class="toc"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">4 New Critical Consciousness</span></p>
<p class="toc"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">5 The <em>Bildung</em> of Community</span></p>
<p class="toca"><span href="#/xhtml/conclusion#con" title="Link target outside of Sample">· Conclusion</span></p>
<p class="tocat"><span href="#/xhtml/notes#not" title="Link target outside of Sample">· <em>Notes</em></span></p>
<p class="toca"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">· <em>Bibliography</em></span></p>
<p class="toca"><span href="#/xhtml/index#ind" title="Link target outside of Sample">· <em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7b81f49c